import { render, staticRenderFns } from "./MainIcon.vue?vue&type=template&id=866ce168&scoped=true&"
var script = {}
import style0 from "./MainIcon.vue?vue&type=style&index=0&id=866ce168&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "866ce168",
  null
  
)

export default component.exports